/* eslint-disable prettier/prettier */
import FaqModel from "../models/Faq";

const faqConstant: FaqModel[] = [
  {
    question:
      "Estou com problemas no aplicativo GerenciAR ou no equipamento de RTU, o que devo fazer?",
    answer:
      "Para defeitos ou problemas no equipamento de RTU, ligue para a Central de Relacionamento com Cliente no 0800 709 9000.",
  },
  {
    question: "Gostaria de acessar o aplicativo GerenciAR pelo celular, o que devo fazer?",
    answer:
      "<a href='/tutorial-gerenciar.pdf'>Clique aqui</a> para acessar o tutorial para a instalação do aplicativo no seu celular.",
  },
  {
    question: "Como posso verificar o nível atual do meu tanque?",
    answer:
      "Na página inicial, é possível visualizar o nível atual em m3 ou KG e o percentual. Caso a instalação possua mais de um tanque, clique na barra inferior do card.",
  },
  {
    question: "Como posso verificar o meu nível histórico?",
    answer:
      "Na página de home, clique no número de instalação do tanque e escolha a aba Níveis (para informação gráfica) ou Histórico de Níveis (para informação detalhada).",
  },
  {
    question: "Como verificar o meu consumo atual e o histórico?",
    answer:
      "Na página inicial, clique no número de instalação do tanque e escolha a aba Consumo (para informação gráfica) ou Histórico de Consumo (para informação detalhada).",
  },
  {
    question: "Como extraio relatórios?",
    answer:
      "No menu do App WM GerenciAR, clique em Relatórios.  No campo Grupo de Instalações, escolha o grupo desejado e selecione a instalação da sua preferência. A ferramenta apresentará os dados solicitados. Para exportar num arquivo, clique no botão Excel ou PDF.",
  },
  {
    question: "O que são os gráficos de boxplot?",
    answer:
      "O boxplot nos fornece uma análise visual da distribuição dos dados, tal como a média ou mediana, a amplitude dos dados (máximo – mínimo), a simetria ou assimetria do conjunto de dados e a presença de outliers.",
  },
  {
    question: "O que são os gráficos de mapa de calor?",
    answer:
      "No gráfico de Mapa de Calor conseguimos identificar os maiores e menores consumos por dia de semana ou slot e assim identificar sua representatividade com relação ao período escolhido.",
  },
  {
    question:
      "Estou verificando um problema no nível do meu equipamento de telemetria, o que fazer?",
    answer:
      "Você pode reportar manualmente o nível do seu tanque. Vá para a página inicial, clique no número de instalação do tanque e escolha a aba “Informar Nível”. Preencha os dados no campo leitura. Para alguns grupos de instalação essa opção pode estar desabilitada. Em caso de problemas, entre em contato com seu Gerente White Martins.",
  },
  {
    question: "Onde ficam os alertas de Nível Crítico e Viagens Planejadas e em Rota?",
    answer:
      "No card da página inicial, o alerta de nível crítico pode ser visualizado na própria figura do tanque na cor vermelha. As viagens planejadas e em rota serão identificadas no canto superior direito do card. Para alguns grupos de instalação essa opção pode estar desabilitada.",
  },
  {
    question: "Preciso criar um novo acesso, como devo proceder?",
    answer:
      "Todo cadastro e/ou configuração de grupos dentro do WM GerenciAR deve ser direcionado ao seu Gerente White Martins.",
  },
];

export default faqConstant;
